<template>
  <div>
    <slider-and-input
      class="mt8"
      :value.sync="numberCount"
      title="小数保留"
      :sliderMin="0"
      :sliderMax="10"
      suffix="位"
      inputWidth="small"
    />
  </div>
</template>

<script>
import publicData from "./publicData"
export default {
  mixins: [publicData],
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    },
  },
  data() {
    return {
      this1: this,
    }
  },
  computed: {
    numberCount: {
      get() {
        let hasNumberCount = this.options.hasOwnProperty("numberCount")
        const number = hasNumberCount ? this.options.numberCount : 2
        if(!hasNumberCount){
          this.checkFormatterValue(number)
          this.$changeOptionsEV(number, "numberCount", false, false, false, true)
        }
        return number
      },
      set(newVal) {
        this.checkFormatterValue(newVal)
        this.$changeOptionsEV(newVal, "numberCount", false, false, false, true)
      }
    },
  },
  mounted() {
  },
  methods: {
    checkFormatterValue(val) {
      let _this = this
      console.log("val", val)
      let series = this.options?.chartOption?.series
      if (series && series.length > 0) {
        let valueUnit = []
        let newSeries = function (params) {
          if(params.seriesType === "liquidFill"){
            let number = 0, str
            if(_this.options?.chartOption.getValueIsPercentage){
              str = "{c}{valueUnit|%}\n{b|{b}}"
            }else{
              let strNumber
              if(params.data.realValue){
                number = getNumber(params.data.realValue)
                strNumber = Number(params.data.realValue)?.toFixed(number)
              } else {
                number = getNumber(params.data.value * params.data.max)
                strNumber = Number(params.data.value * params.data.max)?.toFixed(number)
              }
              str = "{title|"+ strNumber +"}{valueUnit|" + series[params.seriesIndex].unit +"}\n{b|" + params.name + "}"
            }
            return str
          } else if(params.seriesType === "pie"){
            let str
            let number = getNumber(params.value)
            let strNumber = Number(params.value)?.toFixed(number)
            let formatterTypeNumber = series[params.seriesIndex].label.formatterTypeNumber || 1
            if(formatterTypeNumber === 1){
              str = params.name
            }else if(formatterTypeNumber === 2){
              str = params.percent + "%"
            }else if(formatterTypeNumber === 3){
              str = params.name + ":" + params.percent + "%"
            }else if(formatterTypeNumber === 4){
              str = strNumber + ":" + params.percent + "%"
            }else if(formatterTypeNumber === 5){
              str = params.name + ":" + strNumber
            }
            return str
          } else{
            const number = getNumber(params.value)
            let str
            if(_this.options.type === "Radar"){
              str = Number(params.value)?.toFixed(number) + valueUnit[params.seriesIndex]
            }else{
              str = "{title|"+ Number(params.value)?.toFixed(number) +"}{valueUnit|" + valueUnit[params.seriesIndex]+"}"
            }
            return str
          }
        }
        let newToolTip = function (params) {
          if(_this.options.type === "Radar"){
            let indicator = _this.options.chartOption.radar.indicator
            let str = params.name + "</br>"
            indicator.forEach((item, index) => {
              let number = getNumber(params.value[index])
              str += params.marker + "【" + item.name + "】" + "<span style='float: right;margin-left: 20px;'>" + Number(params.value[index])?.toFixed(number) + "</span></br>"
            })
            return str
          } else if(params.seriesType === "liquidFill"){
            let number = getNumber(params.data.realValue)
            let str = params.marker + params.name + "<span style='float: right;margin-left: 20px;'>" + Number(params.data.realValue)?.toFixed(number) + "</span>"
            return str
          } else if(params.seriesType === "pie"){
            let number = getNumber(params.value)
            let str = params.marker + params.name + "<span style='float: right;margin-left: 20px;'>" + Number(params.value)?.toFixed(number) + "</span>"
            return str
          }
          else {
            const number = getNumber(params[0].value)
            let str = params[0].axisValue + "</br>"
            params.forEach(item => {
              str += item.marker + item.seriesName + '<span style="margin-left:30px;float:right;">' + Number(item.value)?.toFixed(number) + '</span>' + "</br>"
            })
            return str
          }
        }
        function getNumber(value) {// 获取小数点个数
          if (!value) return 0
          const arr = value?.toString()?.split(".")
          const numStr = arr && arr.length > 1 ? arr[1].length : 0
          const number = numStr < val ? numStr : val
          return number
        }
        if(_this.options.type === "Radar"){
          series = series[0].data
        }
        series.forEach((item, index) => {
          let chartArr = ["bar", "pictorialBar", "line"]
          if(chartArr.indexOf(item.type) > -1 && !item.label?.show){
            return
          }
          let formatter = item.label?.formatter
          if(!formatter){  //存在formatter为undefined的情况
            formatter = newSeries
            if(_this.options.type === "pie3D" && index < series.length - 1){
              return
            }
          }
          if (item.hasOwnProperty("unit")) {
            valueUnit[index] = item.unit
          } else if (typeof formatter !== "function") {
            const start = formatter.indexOf("|") + 1
            valueUnit[index] = formatter.slice(start, -1)
            if(_this.options.type === "Radar" && start === 0){
              valueUnit[index] = ""
            } else if(_this.options.type === "LiquidFill"){
              if(_this.options?.chartOption.getValueIsPercentage){
                valueUnit[index] = "%"
              }else{
                valueUnit[index] = ""
              }
            }
          } else {
            valueUnit[index] = ""
            if(this.options.type === "Radar"){
              this.$changeOptionsEV("", "chartOption.series.0.data." + index + ".unit", false, false, false, true)
            }else if(_this.options.type !== "Pie" && _this.options.type !== "pie3D"){
              this.$changeOptionsEV("", "chartOption.series." + index + ".unit", false, false, false, true)
            }
          }
          item.unit = valueUnit[index]
          if(_this.options.type === "Radar"){
            this.$changeOptionsEV(newSeries, "chartOption.series.0.data." + index + ".label.formatter", false, false, false, true)
          }else{
            this.$changeOptionsEV(newSeries, "chartOption.series." + index + ".label.formatter", false, false, false, true)
          }
        })
        if(_this.options.chartOption.tooltip.show){
          this.$changeOptionsEV(newToolTip, "chartOption.tooltip.formatter", false, false, false, true)
        }
      }
    },
  }
}
</script>

<style scoped>

</style>
